module.exports = __webpack_public_path__ + "img/living_room.0c9567f6.jpg";